import { mapeamento_laboratorio } from "../Laboratorio/mapeamento_laboratorio";
import CnpjUtils from "../../shared/utils/CnpjUtils";

function extractErrorMessage(json) {
	let mensagem = "";

	if (Array.isArray(json) && json.length > 0 && json[0]?.mensagem) {
		mensagem = json[0].mensagem;
	} else if (json?.mensagem) {
		mensagem = json.mensagem;
	} else if (json?.message) {
		mensagem = json.message;
	} else if (json?.error) {
		mensagem = json.error;
	} else {
		return "Cupom não autorizado.";
	}

	mensagem = mensagem.replace(/Voucher/g, "Cupom").replace(/voucher/g, "cupom");

	return mensagem;
}

async function buscarDadosCupom(codigoCupom) {
	try {
		const apiUrl = process.env.REACT_APP_ESSILOR_API + `gestao-pedidos-laboratorio/v1/vouchers/${codigoCupom}`;

		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"access_token": sessionStorage.getItem("token"),
				"client_id": localStorage.getItem("clientid"),
				"grant_token": sessionStorage.getItem("grant_token"),
			},
		};

		const response = await fetch(apiUrl, requestOptions);

		if (response.status === 200) {
			const data = await response.json();

			return {
				success: true,
				cnpjLab: data.laboratorio,
				cnpjOtica: data.otica,
				id: data.id,
				status: data.status,
				codigo: data.codigo,
				descricao: data.descricao,
				dataCriacao: data.dataCriacao,
				campanha: data.campanha,
				paresQtd: data.paresQtd,
				pares: data.pares || [],
				identificacao: data.identificacao || null,
			};
		} else if (response.status === 403) {
			const json = await response.json();
			const error_msg = extractErrorMessage(json);

			return {
				success: false,
				status: 403,
				message: error_msg,
			};
		} else if (response.status === 404) {
			return {
				success: false,
				status: 404,
				message: "Não foi possível consultar o cupom informado. Por favor, verifique o código e tente novamente.",
			};
		} else if (response.status === 500) {
			return {
				success: false,
				status: 500,
				message: "Erro interno no Essilor Promo. Favor tentar novamente mais tarde.",
			};
		} else {
			return {
				success: false,
				status: response.status,
				message: "Cupom inválido.",
			};
		}

	} catch (error) {
		console.error("Erro ao buscar dados do cupom:", error);
		return {
			success: false,
			status: 0,
			message: "Erro ao consultar voucher. Verifique sua conexão e tente novamente.",
		};
	}
}

async function validarAcessoCupom(codigoCupom, cnpjLab) {
	try {
		const apiUrl = process.env.REACT_APP_ESSILOR_API + `gestao-pedidos-laboratorio/v1/vouchers/${codigoCupom}`;

		const requestOptions = {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"access_token": sessionStorage.getItem("token"),
				"client_id": localStorage.getItem("clientid"),
				"grant_token": sessionStorage.getItem("grant_token"),
				"laboratorio": CnpjUtils.cleanCnpj(cnpjLab),
			},
		};

		const response = await fetch(apiUrl, requestOptions);

		if (response.status === 200) {
			return {
				success: true,
			};
		} else if (response.status === 403) {
			const json = await response.json();
			const error_msg = extractErrorMessage(json);

			return {
				success: false,
				status: 403,
				message: error_msg,
			};
		} else {
			return {
				success: false,
				status: response.status,
				message: "Erro ao validar acesso ao cupom.",
			};
		}

	} catch (error) {
		console.error("Erro ao validar acesso ao cupom:", error);
		return {
			success: false,
			status: 0,
			message: "Erro ao validar acesso. Verifique sua conexão e tente novamente.",
		};
	}
}

export async function consultarVoucher(codigoCupom, userSession = null) {
	const dadosCupom = await buscarDadosCupom(codigoCupom);

	if (!dadosCupom.success) {
		return dadosCupom;
	}

	if (userSession) {
		const cnpjLabMapeado = await mapeamento_laboratorio(dadosCupom.cnpjLab);
		const cnpjParaValidacao = cnpjLabMapeado !== false ? cnpjLabMapeado : dadosCupom.cnpjLab;

		const validacao = await validarAcessoCupom(codigoCupom, cnpjParaValidacao);

		if (!validacao.success) {
			return validacao;
		}
	}

	return dadosCupom;
}